// src/components/Stats.js
import React from 'react';
import { Users, TrendingUp, Award } from 'lucide-react';
import AnimatedCounter from './AnimatedCounter'; // Ważny jest import lokalny

const Stats = () => {
  const statsData = [
    { id: 1, number: 100, suffix: '+', label: 'Zadowolonych klientów', icon: <Users className="w-8 h-8" /> },
    { id: 2, number: 150, suffix: '+', prefix: '', label: 'Milionów PLN dotacji', icon: <TrendingUp className="w-8 h-8" /> },
    { id: 3, number: 10, suffix: '+', label: 'Lat doświadczenia', icon: <Award className="w-8 h-8" /> }
  ];
  
  return (
    // ZMIANA: Powrót do ciemnego tła
    <section className="py-16 md:py-24 relative overflow-hidden bg-black">
      {/* ZMIANA: Subtelny gradient na czarnym tle */}
      <div className="absolute inset-0 bg-gradient-to-b from-black via-indigo-950/10 to-black"></div>
      {/* ZMIANA: Dodana linia przejściowa na górze */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-px bg-gradient-to-r from-transparent via-white/20 to-transparent"></div>
     
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white mb-4 uppercase leading-tight" style={{ fontFamily: 'Inter, sans-serif', fontWeight: 900 }}>
            Nasze osiągnięcia
          </h2>
          <p className="text-lg text-gray-400">Liczby, które mówią same za siebie</p>
        </div>
       
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-8">
          {statsData.map((stat, index) => (
            <div
              key={stat.id}
              className="group glass rounded-2xl md:rounded-3xl p-5 md:p-8 text-center md:hover:scale-105 transition-all duration-300 hover:shadow-2xl hover:shadow-white/5 border border-white/5 hover:border-white/10"
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <div className="inline-flex items-center justify-center w-16 h-16 bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl mb-4 group-hover:border-white/40 transition-all duration-300">
                <span className="text-white/80 group-hover:text-white transition-colors">
                  {stat.icon}
                </span>
              </div>
              <div className="text-4xl lg:text-6xl font-bold mb-2 bg-gradient-to-r from-white via-gray-200 to-white bg-clip-text text-transparent">
                <AnimatedCounter
                  target={stat.number}
                  suffix={stat.suffix}
                  prefix={stat.prefix}
                />
              </div>
              <div className="text-gray-400 text-base font-medium">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;